import { create } from 'apisauce'

import config from 'app/config'
import store from 'store'
import i18n from 'app/i18n'

// import { logoutMe } from 'store/actionCreators/me'
// import { clearSession } from 'store/actionCreators/session'
// import { clearContextParameters } from 'store/actionCreators/contextParameters'

const http = create({
  baseURL: `${config.baseApi}/api`,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})

export const httpSemBaseApi = create({})

http.addRequestTransform(request => {
  const { me } = store.getState()
  const token = me ? me.id : null

  if (token) {
    request.headers['X-Auth-Token'] = token
    request.headers['locale'] = i18n.language
  }
})

// http.addMonitor(res => {
//   if (res.status === 401 || res.status === 403) {
// store.dispatch(logoutMe())
// store.dispatch(clearSession())
// store.dispatch(clearContextParameters())
//TODO: Criar melhoria para mostrar mensagem ou redirecionar para tela de não autorizado em vez de deslogar
//   }
// })

export default http

export const downloadXls = ({ headers, data }) => {
  const disposition = headers['content-disposition']
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  const matches = filenameRegex.exec(disposition)
  const fileName = matches ? matches[1].replace(/['"]/g, '') : 'Relatório.xlsx'
  const blobURL = window.URL.createObjectURL(data)
  const tempLink = document.createElement('a')

  tempLink.style.display = 'none'
  tempLink.href = blobURL
  tempLink.setAttribute('download', fileName)
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
  window.URL.revokeObjectURL(blobURL)
}

export const downloadFile = ({ headers, data }) => {
  const disposition = headers['content-disposition']
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  const matches = filenameRegex.exec(disposition)
  const fileName = matches ? matches[1].replace(/['"]/g, '') : 'arquivo'

  const blobURL = window.URL.createObjectURL(data)
  const tempLink = document.createElement('a')

  tempLink.style.display = 'none'
  tempLink.href = blobURL
  tempLink.setAttribute('download', fileName)
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
  window.URL.revokeObjectURL(blobURL)
}
